export const PERSISTED_REDUCERS = ['userPreferences', 'bag'];
